import Vue from 'vue'
import Boekingen from '../vue/Boekingen.vue'

export default {
  init() {
    new Vue({
      el: '#app',
      components: {
        Boekingen,
      },
    })
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/boekingen.js